//components/prompt-card.tsx
import Link from 'next/link'
import { Sparkles } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Prompt2 } from '@/types/schema'

interface PromptCardProps {
  prompt: Prompt2
}

export function PromptCard({ prompt }: PromptCardProps) {

  const promptColor= prompt.category.color || 'bg-slate-100'
  return (
    <Link href={`/prompt/${prompt.value.current}`}>
      <Card className="h-full shadow-none hover:shadow-lg transition-shadow duration-300 overflow-hidden">
        <CardHeader className={`p-0 ${promptColor} flex min-h-40 items-center justify-center h-36 rounded-t-lg border-b border-gray-200 overflow-hidden`}>
          <div className="aspect-[2/1] flex items-center justify-center">
            {prompt.subcategory?.icon ? (
              <span className="text-3xl">{prompt.subcategory.icon}</span>
            ) : (
              <Sparkles className="h-8 w-8 text-slate-400" />
            )}
          </div>
        </CardHeader>
        <CardContent className="space-y-4 p-4">
          <div className="space-y-2">
          <CardTitle className="text-lg mb-2 text-gray-800 line-clamp-3">{prompt.title}</CardTitle>
            <p className="text-sm text-gray-600 line-clamp-3">
              {prompt.description}
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Badge 
              className='font-medium bg-gray-100'
              variant="secondary"
            >
              {prompt.category?.title}
            </Badge>
            <Badge 
              className='font-medium bg-gray-100'
              variant="secondary"
            >
              {prompt.subcategory?.title}
            </Badge>
          </div>
        </CardContent>
      </Card>
    </Link>
  )
}

